const comments = [
  {
    name: '电影爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%20with%20warm%20lighting%2C%20friendly%20expression%2C%20simple%20cream%20background%2C%20clean%20professional%20look%2C%20soft%20natural%20light&width=80&height=80&seq=avatar-cinema-01&orientation=squarish',
    date: '3天前',
    content: '用了51影院半年了，资源真的很全。之前要找的几部冷门纪录片在奇优影院和97影院上都没有，但在51影院一次性就找到了，画质还是高清的，太方便了！',
  },
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20smiling%2C%20warm%20lighting%2C%20simple%20cream%20background%2C%20clean%20professional%20look%2C%20soft%20natural%20light&width=80&height=80&seq=avatar-cinema-02&orientation=squarish',
    date: '5天前',
    content: '追剧党的福音！《长相思》更新的那天晚上我就在这里第一时间看到了，比我在其他平台等得还快。而且播放全程没有缓冲，在家用iPad看体验超好。',
  },
  {
    name: '科幻迷老张',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle-aged%20Asian%20man%20with%20warm%20lighting%2C%20confident%20expression%2C%20simple%20cream%20background%2C%20clean%20professional%20look%2C%20soft%20natural%20light&width=80&height=80&seq=avatar-cinema-03&orientation=squarish',
    date: '1周前',
    content: '国产科幻这几年真的起飞了，从《流浪地球》到《三体》，51影院更新速度非常快，高清片源质量也很好。推荐所有科幻迷来这个平台看！',
  },
  {
    name: '综艺控小李',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20person%20with%20warm%20lighting%2C%20cheerful%20expression%2C%20simple%20cream%20background%2C%20clean%20professional%20look%2C%20soft%20natural%20light&width=80&height=80&seq=avatar-cinema-04&orientation=squarish',
    date: '2周前',
    content: '《奔跑吧》和《王牌》每期我都追，51影院更新跟电视台同步，而且可以随时暂停回看精彩片段。窝窝影院和第九影院的资源这里都有，不用来回切换了！',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-chat-smile-2-line"></i>用户声音
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-3">观众真实评价</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            来自影视爱好者的真实使用反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {comments.map((comment) => (
            <div key={comment.name} className="bg-background-50 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <span className="block text-sm font-medium text-foreground-900">{comment.name}</span>
                  <span className="text-xs text-foreground-500">{comment.date}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}